import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet, useParams } from 'react-router-dom';
import { NotificationProvider } from './context/ContextNotification';
import Home from './pages/Home';
import Courses from './pages/Courses';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Signup from './pages/Signup';
import Exercises from './pages/Exercises';
import Dashboard from './pages/Dashboard';
import CourseDetail from './pages/CourseDetail';
import VocabularyDetail from './pages/VocabularyDetail';
import ExerciceVocabulaireCorrespondance from './pages/ExerciceRushCorrespondance';
import ExerciceVocabulaireClassique from './pages/VocabularyExercices';
import WordSearchExercise from './pages/VocabulaireMotMelee';
import CourseEdit from './pages/CourseEdit';
import ExerciseDetail from './pages/ExerciseDetail';
import Header from './components/Header';
import { UserProvider } from './UserContext';
import './index.css';
import './i18n';
import useWebSocket from "./hooks/HookWebSocket";
import GTMPageView from './components/GTMPageView';

// Composant Layout qui extrait les paramètres et encapsule le Header et les routes imbriquées
function Layout() {
  const { interfaceLang, courseLang } = useParams();
  console.log("Chargement dans Layout :", interfaceLang, courseLang);
  return (
    <UserProvider interfaceLang={interfaceLang} courseLang={courseLang}>
      <Header />
      <Outlet />
    </UserProvider>
  );
}

function AppWrapper() {
  // Définir la langue par défaut en fonction du navigateur
  const userLang = navigator.language.startsWith('fr') ? 'fr' : 'en';

  return (
    <Routes>
      {/* Redirection de la racine vers la langue par défaut */}
      <Route path="/" element={<Navigate to={`/${userLang}`} replace />} />
      
      {/* Route principale pour les pages qui nécessitent interfaceLang */}
      <Route path="/:interfaceLang/*" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="courses/:courseLang" element={<Courses />} />
        <Route path="course/:courseLang/:courseSlug" element={<CourseDetail />} />
        
        <Route path="course/:courseLang/:courseSlug/edit" element={<CourseEdit />} />
        <Route path="course/:courseLang/:courseSlug/exercise/:exerciseId" element={<ExerciseDetail />} />
      
        <Route path="courses/:courseLang/vocabulary/:vocabularyCategory" element={<VocabularyDetail />} />
        <Route path="courses/:courseLang/vocabulary/:vocabularyCategory/exercise/matches" element={<ExerciceVocabulaireCorrespondance />} />
        <Route path="courses/:courseLang/vocabulary/:vocabularyCategory/exercise/mot-melee" element={<WordSearchExercise />} />
        <Route path="courses/:courseLang/vocabulary/:vocabularyCategory/exercise/:exerciseType" element={<ExerciceVocabulaireClassique />} />
      </Route>
      
      {/* Routes indépendantes ne nécessitant pas d'interfaceLang */}
      <Route path="/logout" element={<Logout />} />
      <Route path="/exercises/:id" element={<Exercises />} />
    </Routes>
  );
}

function App() {
  const token = localStorage.getItem("access_token");
  const WS_URL = process.env.REACT_APP_WS_URL;
  const socket = useWebSocket(`${WS_URL}/notifications/`, token); // Initialise WebSocket si token existe

  return (
    <NotificationProvider socket={socket}>
      <HelmetProvider>
        <Router>
          <GTMPageView />
          <AppWrapper />
        </Router>
      </HelmetProvider>
    </NotificationProvider>
  );
}

export default App;
